"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutosweepBehavior = void 0;
/**
 * Autosweep: automatic recurring sweeps of third-party credit-card balances onto an Aven Rewards (UCC)
 * card. Each swept tranche gets 0% APR for a fixed 30 days and then moves to the standard revolving
 * plan; the account APR is discounted while autosweep is enabled.
 *
 * Only the behavior enum is shared. Everything else autosweep types — the audit vocabularies and the ledger
 * statuses — is declared on the backend entity owning the column, since no frontend reads it. Anything added
 * here should be something the app genuinely renders.
 */
var AutosweepBehavior;
(function (AutosweepBehavior) {
    AutosweepBehavior["enabled"] = "enabled";
    AutosweepBehavior["disabled"] = "disabled";
})(AutosweepBehavior || (exports.AutosweepBehavior = AutosweepBehavior = {}));
